import type { IDashboardCardVariantData } from "@components/molecules/dashboardCard/types";

export const dashboardCardVariants: IDashboardCardVariantData = {
  academicFieldCount: { color: "#B0BF89", icon: "Buildings" },
  facultyCount: { color: "#16A186", icon: "Buildings" },
  conferencePaperCount: { color: "#B0BF89", icon: "Book" },
  facultyMemberCount: { color: "#0C6291", icon: "UsersGroupRounded" },
  localAdminsCount: { color: "#564766", icon: "UsersGroupRounded" },
  researchProposalCount: { color: "#05233F", icon: "SquareAcademicCap" },
  journalPaperCount: { color: "#16A186", icon: "Book" },
  staffsCount: { color: "#CC2936", icon: "UsersGroupRounded" },
  usersCount: { color: "#05233F", icon: "UsersGroupRounded" },
  studentCount: { color: "#546078", icon: "UsersGroupRounded" },
};
